import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
} from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import {
  formValidations,
  motivoViagemList,
  tipoDocumentoListPF,
  transporteUtilizadoList,
} from 'src/app/core/constants/selects-constants';
import { ApiService } from 'src/app/core/services/api.service';
import { ReservaFNRHDTO } from 'src/app/core/types';

@Component({
  selector: 'others-info-form',
  templateUrl: './others-info-form.component.html',
  styleUrls: ['./others-info-form.component.scss'],
})
export class OthersInfoFormComponent implements OnChanges {
  public formPersonal: FormGroup = new FormGroup({
    motivoViagem: new FormControl(),
    observacao: new FormControl(),
    transporteUtilizado: new FormControl(),
  });

  public validationMessages = formValidations;
  public tipoDocumentoList = tipoDocumentoListPF;

  public motivoViagemList = motivoViagemList;
  public transporteUtilizadoList = transporteUtilizadoList;

  @Input() fnrh: ReservaFNRHDTO = {} as ReservaFNRHDTO;
  @Input() showFnrhForm: boolean = false;
  @Output() saveFormFNRH: EventEmitter<ReservaFNRHDTO> =
    new EventEmitter<ReservaFNRHDTO>();
  @Output() cancelForm: EventEmitter<null> = new EventEmitter<null>();

  constructor(private fb: FormBuilder, private apiService: ApiService) {}

  ngOnChanges(): void {
    this.initForm();
  }

  initForm() {
    this.formPersonal = this.fb.group({
      observacao: [this.fnrh.observacao],
      transporteUtilizado: [this.fnrh.transporteUtilizado],
      motivoViagem: [this.fnrh.motivoViagem],
    });
  }

  activeValidatorsFisica() {
    this.formPersonal.controls['dataNascimento'].setValidators([
      Validators.required,
    ]);
    this.formPersonal.updateValueAndValidity();
  }

  clearFormErrors() {
    Object.keys(this.formPersonal.controls).forEach((key) => {
      this.formPersonal.controls[key].setErrors(null);
      this.formPersonal.controls[key].updateValueAndValidity();
    });
  }

  onCancel() {
    this.cancelForm.emit();
  }

  onSave() {
    if (this.validateForm()) {
      const formData: ReservaFNRHDTO = {
        ...this.fnrh,
        ...this.formPersonal.value,
      } as ReservaFNRHDTO;

      this.saveFormFNRH.emit(formData);
    }
  }

  validateForm() {
    this.clearFormErrors();
    return this.formPersonal.valid;
  }
}
